import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { BatchContent, BatchContentType, BatchUIMobile } from "models/batch/BatchContent";
import { updateBatchContentDO, getBatchContentDO, deleteBatchContentDO } from "utils/questionsUtils";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
const MDInput = require("components/MDInput/index.js").default;
import { addAlert, useAuth, useMaterialUIController } from "context";
import ItemPageContainer from "layouts/itemPageContainer";
import CardItem from "components/alove/CardItem";
import { Prevalidate } from "../question/component/prevalidate";
import { DropdownButton } from "components/alove/DropDownButton";
import { Grid } from "@mui/material";
import { ItemHeader } from "layouts/itemPageContainer/userItem/itemHeader";
import { camelCaseToCapitalizedWords } from "utils/globalsUtils";
import { QuestionType } from "models/batch/Question";
import PostActionEditor from "./components/postAction";
import { PageNumber } from "accessNumbers";
import { PermissionType } from "models/BO/BoRole";

export default function EditBatchContent() {
  const { id } = useParams();
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = useAuth();
  const [batchContent, setBatchContent] = useState<BatchContent | null>(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    async function fetchBatchContent() {
      setLoading(true);
      // Replace with actual fetch logic for batch content by id
      const res = await getBatchContentDO(Number(id));
      setBatchContent(Object.assign(new BatchContent(), res));
      setLoading(false);
    }
    if (id) fetchBatchContent();
  }, [id]);

  const handleChange = async (field: any, value: any) => {
    if (!batchContent) return;
    batchContent[field] = value;
    setBatchContent(Object.assign(new BatchContent(), batchContent));
    await updateBatchContentDO(batchContent.id, batchContent);
  };

  const deleteBatchContent = async () => {
    if (!batchContent) return;
    await deleteBatchContentDO(batchContent.id);
    navigate(-1)
  };

  const type = () =>
    Object.keys(BatchUIMobile).find(
      (key) => BatchUIMobile[key] === batchContent?.visSettings?.ui_mobile
    ) || "Message";

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={`Edit Batch Content #${id}`} />
      <ItemPageContainer
        loader={loading }
        navItems={[
          {
            label: "Edit Batch Content",
            ref: "edit",
          },
          {
            label: "Pre-Validation",
            ref: "preValidation",
          },
          {
            label: "Post-Validation",
            ref: "postValidation",
          },
        ]}
        itemStatus={{
          item: batchContent!,
          title: "Batch Content Status",
          isManager: true,
          changeStatus: (status) => {
            batchContent!.status = status;
            return handleChange("contentStateId", status)
          }
        }}
        itemHeader={
          <ItemHeader title="Question Details" indications={[{ title: "Type", value: type() }]} />
        }
        deleteItem={
          {
            contetnText: "Are you sure you want to delete this batch content?",
            buttonText: "Delete",
            hidden: !currentRole.hasAccess(PageNumber.ViewQuestion, PermissionType.Delete),
            onDelete: () => {
              return deleteBatchContent();
            }
          } 
        }
      >
        <CardItem title="Edit Batch Content" id="edit">
          <Grid container spacing={2} flexDirection="row">
            <Grid
              size={{
                md: 6
              }}>
            <MDInput
              label="Text"
              value={batchContent?.contentTxtId || ""}
              onChange={(e) => handleChange("contentTxtId", e.target.value)}
              fullWidth
              multiline
            />
            </Grid>
            <Grid
              size={{
                md: 6
              }}>
            <DropdownButton
              label={type()}
              options={Object.keys(BatchUIMobile).map((key) => ({
                label: key,
                value: BatchUIMobile[key],
              }))}
                onClick={(e) =>
                  handleChange("visSettings", { ...batchContent?.visSettings, ui_mobile: e.value })
                }
              />
            </Grid>
          </Grid>
        </CardItem>
        <CardItem title="Pre-Validation" id="preValidation" defaultClosed>
          <Prevalidate
            preValidation={batchContent?.preValidation || []}
            updatePrevalidation={(preValidation) => handleChange("preValidation", preValidation)}
          />
        </CardItem>
        <CardItem title="Post Action" id="postValidation" defaultClosed>
          <PostActionEditor
            postActions={batchContent?.postConditionAction || []}
            updatePostActions={(postActions) => handleChange("postConditionAction", postActions)}
          />
        </CardItem>
      </ItemPageContainer>
    </DashboardLayout>
  );
}
